import { request } from '@/utils/api-request'

export function getChartData (params) {
  const url = '/api/admin/dashboard/get_chart_data'

  const config = {
    method: 'post',
    url,
    data: params
  }
  return request(config, true)
}

export function getDailyReportData (params) {
  const url = '/api/admin/dashboard/daily_report'

  const config = {
    method: 'post',
    url,
    data: params
  }
  return request(config, true)
}

export function getDailyCardData (force) {
  const url = '/api/admin/dashboard/daily_card'

  const config = {
    method: 'get',
    url
  }
  return request(config, force, '24h')
}
